import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import videoData from "./videoData.json"; // Adjust the path as needed

const VideoDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [currentVideo, setCurrentVideo] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);

  // When the slug changes, look up the matching video in the JSON data.
  useEffect(() => {
    if (slug) {
      const video = videoData.find((v) => v.slug === slug);
      setCurrentVideo(video);
    }
  }, [slug]);

  // If no matching video is found, show an error message.
  if (!currentVideo) {
    return (
      <div className="p-6">
        <p>Video not found.</p>
        <button
          onClick={() => navigate("/videos")}
          className="mt-4 text-blue-500 hover:underline"
        >
          Back to Videos
        </button>
      </div>
    );
  }

  // Share the current video URL (which includes the slug) to the clipboard.
  const handleShare = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => alert("Video link copied to clipboard!"))
      .catch(() => alert("Failed to copy video link."));
  };

  return (
    <div className="p-6">
      <button
        onClick={() => navigate("/videos")}
        className="text-blue-500 hover:underline"
      >
        &larr; Back to Videos
      </button>
      <h2 className="text-2xl font-bold text-gray-800 mt-4 mb-4">
        {currentVideo.name}
      </h2>
      <p className="mb-4 text-gray-700">{currentVideo.summary}</p>
      {/* Button to show the video player */}
      <button
        onClick={() => setShowPlayer(true)}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
      >
        Play Video
      </button>
      {showPlayer && (
        <div className="mt-4">
          <video
            className="w-full max-w-3xl rounded-md shadow-md"
            src={currentVideo.videoUrl}
            controls
            autoPlay
          />
        </div>
      )}
      {/* Share Button */}
      <button
        onClick={handleShare}
        className="mt-4 px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
      >
        Share Video
      </button>
      <p className="mt-2 text-gray-600">
        Video Link:{" "}
        <span className="underline break-all">{window.location.href}</span>
      </p>
    </div>
  );
};

export default VideoDetails;
